import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";

export default function PromoAnimaliaManager() {
  const [promoData, setPromoData] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [fileMap, setFileMap] = useState({}); // store selected files per promo id

  useEffect(() => {
    fetchPromoData();
  }, []);

  const fetchPromoData = async () => {
    const { data, error } = await supabase.from("promo_animalia_section").select("*");
    if (error) console.error("Error fetching data:", error);
    else setPromoData(data);
  };

  const handleFileChange = (e, promoId) => {
    const file = e.target.files[0];
    if (file) {
      setFileMap((prev) => ({ ...prev, [promoId]: file }));
    }
  };

  const handleUploadImage = async (promoId) => {
    const file = fileMap[promoId];
    if (!file) return;

    setUploading(true);
    const fileExt = file.name.split('.').pop();
    const filePath = `animalia/${Date.now()}.${fileExt}`;

    const { error: uploadError } = await supabase.storage
      .from("animalia")
      .upload(filePath, file);

    if (uploadError) {
      console.error("Upload failed:", uploadError);
      setUploading(false);
      return;
    }

    const { data: publicUrlData } = supabase.storage
      .from("animalia")
      .getPublicUrl(filePath);

    const newImageUrl = publicUrlData?.publicUrl;
    const promo = promoData.find((item) => item.id === promoId);
    const updatedImages = [...(promo.promo_images || []), newImageUrl];

    const { error: updateError } = await supabase
      .from("promo_animalia_section")
      .update({ promo_images: updatedImages })
      .eq("id", promoId);

    if (updateError) console.error("Error updating image array:", updateError);
    setUploading(false);
    setFileMap((prev) => ({ ...prev, [promoId]: null }));
    fetchPromoData();
  };

  const handleDeleteImage = async (id, imageUrl) => {
    const record = promoData.find((item) => item.id === id);
    const updatedImages = record.promo_images.filter((img) => img !== imageUrl);
    const { error } = await supabase
      .from("promo_animalia_section")
      .update({ promo_images: updatedImages })
      .eq("id", id);
    if (error) console.error("Error deleting image:", error);
    fetchPromoData();
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", background: "#f0f0f0", minHeight: "80vh", padding: "40px" }}>
      <div style={{ width: "100%", maxWidth: "900px", background: "#fff", padding: "30px", borderRadius: "10px", boxShadow: "0 0 12px rgba(0,0,0,0.1)" }}>
<h2 style={{ marginBottom: "30px", textAlign: "center" }}>
  Gestionnaire d’Images Promo Animalia
</h2>

        {promoData.map((promo) => (
          <div key={promo.id} style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "20px", marginBottom: "30px" }}>
            {/* <h3>Promo ID: {promo.id}</h3> */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
              {promo.promo_images && promo.promo_images.length > 0 ? (
                promo.promo_images.map((img, index) => (
                  <div key={index} style={{ position: "relative" }}>
                    <img
                      src={img}
                      alt={`Promo ${index}`}
                      style={{ width: "120px", height: "120px", objectFit: "cover", borderRadius: "8px" }}
                    />
                    <button
                      onClick={() => handleDeleteImage(promo.id, img)}
                      style={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                        background: "#f44336",
                        border: "none",
                        color: "#fff",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        cursor: "pointer"
                      }}
                    >
                      &times;
                    </button>
                  </div>
                ))
              ) : (
                <p>No images found.</p>
              )}
            </div>

            <div style={{ marginTop: "16px", display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, promo.id)}
                style={{ padding: "6px" }}
              />
              <button
                onClick={() => handleUploadImage(promo.id)}
                disabled={uploading}
                style={{
                  padding: "8px 14px",
                  backgroundColor: "#888",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: uploading ? "not-allowed" : "pointer"
                }}
              >
                {uploading ? "Uploading..." : "Upload Image"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
